import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './BrinjalPage.css';
import brinjalLogo from '../images/brinjal-logo.png';
import brinjalLalita from '../images/Brinjal-lalitha-img.png';
import birinjalYashoda from "../images/brinjal-yashoda-img.png"

const varieties = [
  {
    name: 'YASHODA',
    image: birinjalYashoda,
    description: [
      'Hybrid Brinjal YASHODA by Dynasty Agriseeds',
      'Versatile and reliable hybrid engineered for consistent performance across seasons',
      'Fruit profile: Oblong shape, green skin with white patches',
      'First harvest starts in about 65 days after sowing',
      'Productive harvest duration of 3-4 months with proper crop care',
      'Sowing window: June to February',
      'Known for steady yield and strong market preference',
    ],
  },
  {
    name: 'LALITA',
    image: brinjalLalita,
    description: [
      'Semi-erect plant type with spreading nature',
      'Rich violet fruit colour with white stripes',
      'Fruit shape: Oval',
      'Fruit weight: 60-70 gm',
      'Good yield potential',
    ],
  },
  
];

export default function BrinjalPage() {
  return <ProductPatternPage title="Brinjal" varieties={varieties} pageClass="brinjal-page" heroImage={brinjalLogo} />;
}
